class NewProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.addEventListener("linked-product-change", (e) =>
      this.handleProductChange(e)
    );
    this.quickViewElement = this.querySelector("quick-view");
    this.templateName = this.dataset.template ?? "product-card";
    this.quickAddTriggerElement = this.querySelector(
      "[data-quick-add-trigger]"
    );
    if (this.quickViewElement) {
      this.querySelectorAll(".product-card-gallery__image-container").forEach(
        (el) => {
          el.addEventListener("click", (e) => {
            e.preventDefault();
            this.quickViewElement.classList.add("active");
          });
        }
      );
    }
    this.addEventListener("click", (e) => {
      if (e.target.closest("[data-quick-add-trigger]")) {
        e.preventDefault();
        this.querySelector("quick-add")?.classList.add("active");
      }
    });
  }

  handleProductChange(e) {
    const productUrl = e.detail.productUrl;
    this.classList.add("loading");
    fetch(productUrl + "?view=" + this.templateName)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const productCard = doc.querySelector("new-product-card");
        this.innerHTML = productCard.innerHTML;
        this.classList.remove("loading");
        this.init();
      });
  }
}

if (!window.customElements.get("new-product-card")) {
  customElements.define("new-product-card", NewProductCard);
}
class ProductCardGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    const prevBtn = this.querySelector("[data-prev-btn]");
    const nextBtn = this.querySelector("[data-next-btn]");

    let prevLabel, nextLabel;
    if (prevBtn) {
      prevLabel =
        prevBtn.getAttribute("aria-label") || "Go to the previous slide";
      prevBtn.setAttribute("aria-label", prevLabel);
    }

    if (nextBtn) {
      nextLabel = nextBtn.getAttribute("aria-label") || "Go to the next slide";
      nextBtn.setAttribute("aria-label", nextLabel);
    }
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: prevLabel,
        nextSlideMessage: nextLabel,
      },
    });
  }
}
if (!window.customElements.get("product-card-gallery")) {
  customElements.define("product-card-gallery", ProductCardGallery);
}

class LinkedProductSwatch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.dispatchEvent(
        new CustomEvent("linked-product-change", {
          detail: {
            productUrl: this.dataset.productUrl,
          },
          bubbles: true,
        })
      );
    });
  }
}

if (!window.customElements.get("linked-product-swatch")) {
  customElements.define("linked-product-swatch", LinkedProductSwatch);
}

class FeaturedCollectionSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    const prevBtn = this.querySelector("[data-fc-prev-btn]");
    const nextBtn = this.querySelector("[data-fc-next-btn]");
    this.swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      slidesOffsetBefore: 16,
      mousewheel: {
        forceToAxis: true
      },
      freeMode: {
        enabled: true,
      },
      breakpoints: {
        767: {
          slidesPerView: 3.8,
          slidesOffsetBefore: 20,
        },
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });
  }
}
if (!window.customElements.get("featured-collection-swiper")) {
  customElements.define("featured-collection-swiper", FeaturedCollectionSwiper);
}

class FeaturedCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.triggerElements = this.querySelectorAll("[data-collection-trigger]");
    this.targetElements = this.querySelectorAll("[data-collection-target]");
    this.triggerElements.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleTriggerClick(e);
      });
    });
  }

  handleTriggerClick(e) {
    const collectionId = e.target.dataset.collectionTrigger;
    this.targetElements.forEach((el) => {
      el.classList.add("!hidden");
    });
    const collection = this.querySelector(
      `[data-collection-target="${collectionId}"]`
    );
    collection.classList.remove("!hidden");
    this.triggerElements.forEach((el) => {
      el.classList.remove("underline");
    });
    e.target.classList.add("underline");
  }
}

if (!window.customElements.get("featured-collections")) {
  customElements.define("featured-collections", FeaturedCollections);
}

class QuickAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.quickAddTriggerElement = this.querySelector(
      "[data-quick-add-trigger]"
    );
    this.quickAddTriggerElement.addEventListener("click", (e) => {
      e.preventDefault();
      this.show();
    });
    this.addEventListener("mouseleave", () => {
      this.hide();
    });

    document.addEventListener("scroll", () => {
      this.hide();
    });
  }

  hide() {
    this.classList.remove("active");
  }
}

if (!window.customElements.get("quick-add")) {
  customElements.define("quick-add", QuickAdd);
}

class QuickAddForm extends HTMLElement {
  constructor() {
    super();
  }

  get formId() {
    return this.getAttribute("id");
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.form = this.querySelector("form");
    this.masterSelect = this.querySelector("[name='id']");
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
    this.addEventListener("add-to-cart", this.handleSubmit.bind(this));
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    this.masterSelect.value = variant.id;
  }

  handleSubmit(event) {
    event.preventDefault();
    this.submit();
  }

  submit() {
    const formData = new FormData(this.form);
    formData.append("id", this.masterSelect.value);
    formData.append("quantity", 1);
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        document.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
            },
          })
        );
        document.querySelector("cart-drawer")?.show();
      })
      .catch((err) => console.error(err))
      .finally(() => {
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:end", { bubbles: true })
        );
      });
  }
}

if (!window.customElements.get("quick-add-form")) {
  window.customElements.define("quick-add-form", QuickAddForm);
}

class NewVariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.variants = JSON.parse(
      this.querySelector("[data-variants]").textContent
    );
    this.currentVariant = null;
    this.optionInputs = this.querySelectorAll("input");
    this.bindEvents();
  }

  bindEvents() {
    this.listenToChange();
  }

  listenToChange() {
    this.optionInputs.forEach((input) =>
      input.addEventListener("change", (e) => {
        e.preventDefault();
        this.updateCurrentVariant(e.target);
      })
    );
  }

  updateCheckedInputs() {
    this.optionInputs.forEach((input) => {
      if (input.checked) {
        input.setAttribute("checked", "checked");
      } else {
        input.removeAttribute("checked");
      }
    });
  }

  getSelectedValues() {
    return Array.from(this.querySelectorAll("input:checked")).reduce(
      (acc, input) => {
        acc[input.name] = input.value;
        return acc;
      },
      {}
    );
  }

  updateCurrentVariant(input = null) {
    const isAddOnClick = input?.dataset.addOnClick == "true";
    this.updateCheckedInputs();
    const selectedValues = this.getSelectedValues();

    this.currentVariant =
      this.variants.find((variant) => {
        return Object.entries(selectedValues).every(([name, value]) => {
          return variant[name] === value;
        });
      }) || null;

    if (this.currentVariant) {
      this.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: {
            variant: this.currentVariant,
          },
          bubbles: true,
        })
      );
    }

    if (isAddOnClick) {
      this.dispatchEvent(
        new CustomEvent("add-to-cart", {
          bubbles: true,
        })
      );
    }
  }
}

if (!window.customElements.get("new-variant-picker")) {
  window.customElements.define("new-variant-picker", NewVariantPicker);
}

class FeaturedCollectionList extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.triggerElements = this.querySelectorAll("[data-collection-trigger]");
    this.targetElements = this.querySelectorAll("[data-collection-target]");
    this.triggerElements.forEach((el) => {
      el.addEventListener("mouseover", (e) => {
        this.handleTriggerMouseover(e);
      });
    });
  }

  handleTriggerMouseover(e) {
    this.targetElements.forEach((el) => {
      el.classList.add("hidden");
    });
    const target = this.querySelector(
      `[data-collection-target="${e.target.dataset.collectionTrigger}"]`
    );
    target.classList.remove("hidden");
  }
}

if (!window.customElements.get("featured-collection-list")) {
  window.customElements.define(
    "featured-collection-list",
    FeaturedCollectionList
  );
}

class ReviewCardsSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      slidesOffsetBefore: 16,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        767: {
          slidesPerView: 3.7,
          slidesOffsetBefore: 20,
        },
      },
    });
  }
}

if (!window.customElements.get("review-cards-swiper")) {
  window.customElements.define("review-cards-swiper", ReviewCardsSwiper);
}

class SlideshowSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: this.dataset.slideshowSpeed * 1000,
      },
    });
  }
}

if (!window.customElements.get("slideshow-swiper")) {
  window.customElements.define("slideshow-swiper", SlideshowSwiper);
}

class ComingSoonSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1.1,
      spaceBetween: 10,
      slidesOffsetBefore: 14,
      slidesOffsetAfter: 14,
      freeMode: true,
      breakpoints: {
        767: {
          slidesPerView: 3.1,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
        },
      },
    });
  }
}

if (!window.customElements.get("coming-soon-slider")) {
  window.customElements.define("coming-soon-slider", ComingSoonSlider);
}

class WaitlistCountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
  }

  connectedCallback() {
    this.expirationDate = this.dataset.expirationDate;
    this.init();
  }

  init() {
    this.initCountdown();
  }

  initCountdown() {
    if (!this.expirationDate) {
      console.warn("No expiration date provided for countdown timer");
      return;
    }

    // Parse the expiration date
    // Expected format: "YYYY-MM-DD HH:MM" (e.g., "2025-12-25 12:00")
    const targetDate = new Date(this.expirationDate);

    if (isNaN(targetDate.getTime())) {
      console.error(
        'Invalid expiration date format. Expected: "YYYY-MM-DD HH:MM" (e.g., "2025-12-25 12:00")'
      );
      return;
    }

    // Start the countdown immediately
    this.updateCountdown(targetDate);

    // Update every second
    this.intervalId = setInterval(() => {
      this.updateCountdown(targetDate);
    }, 1000);
  }

  updateCountdown(targetDate) {
    const now = new Date();
    const timeLeft = targetDate.getTime() - now.getTime();

    if (timeLeft <= 0) {
      // Countdown has ended
      this.displayTime(0, 0, 0, 0);
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      return;
    }

    // Calculate time components
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    this.displayTime(days, hours, minutes, seconds);
  }

  displayTime(days, hours, minutes, seconds) {
    const daysElement = this.querySelector("[data-days]");
    const hoursElement = this.querySelector("[data-hours]");
    const minutesElement = this.querySelector("[data-minutes]");
    const secondsElement = this.querySelector("[data-seconds]");

    if (daysElement) daysElement.textContent = days.toString().padStart(2, "0");
    if (hoursElement)
      hoursElement.textContent = hours.toString().padStart(2, "0");
    if (minutesElement)
      minutesElement.textContent = minutes.toString().padStart(2, "0");
    if (secondsElement)
      secondsElement.textContent = seconds.toString().padStart(2, "0");
  }

  disconnectedCallback() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

if (!window.customElements.get("waitlist-countdown-timer")) {
  window.customElements.define(
    "waitlist-countdown-timer",
    WaitlistCountdownTimer
  );
}

class WaitlistCollectionCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleTriggerMouseOver = this.handleTriggerMouseOver.bind(this);
    this.init();
  }

  init() {
    this.triggerElements = this.querySelectorAll("[data-collection-trigger]");
    this.targetElements = this.querySelectorAll("[data-collection-target]");
    this.triggerElements.forEach((el) => {
      el.addEventListener("mouseenter", this.handleTriggerMouseOver);
    });
  }

  handleTriggerMouseOver(e) {
    const trigger = e.currentTarget;
    const targetId = trigger.getAttribute("data-collection-trigger");
    if (!targetId) return;
    this.targetElements.forEach((target) => target.classList.add("hidden"));
    const target = this.querySelector(`[data-collection-target="${targetId}"]`);
    target.classList.remove("hidden");
  }
}

if (!window.customElements.get("waitlist-collection-card")) {
  window.customElements.define(
    "waitlist-collection-card",
    WaitlistCollectionCard
  );
}

class WaysToWear extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.triggerElements = Array.from(this.querySelectorAll("[data-index]"));
    this.nameElements = Array.from(this.querySelectorAll("[data-name-index]"));
    this.initSwiper();
    this.addTriggerListeners();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector("[data-ways-to-wear-slider]"), {
      slidesPerView: 1.1,
      spaceBetween: 10,
      breakpoints: {
        767: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
    });

    const triggerElements = this.triggerElements;
    this.swiper.on("slideChange", (e) => {
      const index = e.activeIndex;
      triggerElements.forEach((el) => {
        el.classList.add("opacity-50");
      });
      if (triggerElements[index]) {
        triggerElements[index].classList.remove("opacity-50");
      }

      this.updateNameElements(index);
    });
  }

  updateNameElements(index) {
    this.nameElements.forEach((el) => {
      el.classList.add("hidden");
    });
    if (this.nameElements[index]) {
      this.nameElements[index].classList.remove("hidden");
    }
  }

  addTriggerListeners() {
    if (!this.triggerElements || !this.swiper) return;
    this.triggerElements.forEach((el, idx) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        this.swiper.slideTo(idx);
      });
    });
  }
}

if (!window.customElements.get("ways-to-wear")) {
  window.customElements.define("ways-to-wear", WaysToWear);
}

class KlaviyoForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.form = this.querySelector("form");
    this.apiKey = this.dataset.apiKey;
    this.listId = this.dataset.listId;
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
  }

  handleSubmit(event) {
    event.preventDefault();
    this.submit();
  }

  submit() {
    const email = this.form.querySelector('input[name="email"]').value;

    if (!email) {
      this.showErrorMessage("Please enter a valid email address.");
      return;
    }

    if (!this.apiKey) {
      this.showErrorMessage("Klaviyo API key is not configured.");
      return;
    }

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: this.listId,
            },
          },
        },
      },
    };

    fetch(
      "https://a.klaviyo.com/client/subscriptions?company_id=" + this.apiKey,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-10-15",
        },
        body: JSON.stringify(payload),
      }
    )
      .then((response) => {
        if (response.ok) {
          this.showSuccessMessage();
        } else {
          return response.json().then((data) => {
            console.error("Klaviyo API error:", data);
            this.showErrorMessage(
              "Sorry, there was an error. Please try again."
            );
          });
        }
      })
      .catch((error) => {
        console.error("Klaviyo subscription error:", error);
        this.showErrorMessage("Sorry, there was an error. Please try again.");
      });
  }

  showSuccessMessage() {
    // Remove any existing messages
    this.clearMessages();

    const successDiv = document.createElement("div");
    successDiv.className = "text-[13px] text-green-600";
    successDiv.textContent = "Thank you for subscribing!";
    this.form.parentNode.insertBefore(successDiv, this.form.nextSibling);
    this.form.reset();
  }

  showErrorMessage(message = "Sorry, there was an error. Please try again.") {
    // Remove any existing messages
    this.clearMessages();

    const errorDiv = document.createElement("div");
    errorDiv.className = "text-[13px] text-red-500";
    errorDiv.textContent = message;
    this.form.parentNode.insertBefore(errorDiv, this.form.nextSibling);
  }

  clearMessages() {
    const existingMessages = this.form.parentNode.querySelectorAll(
      ".text-green-600, .text-red-500"
    );
    existingMessages.forEach((msg) => msg.remove());
  }
}

if (!window.customElements.get("klaviyo-form")) {
  window.customElements.define("klaviyo-form", KlaviyoForm);
}
